import React from "react";

export default function NotFound() {
  return (
    <div>
      <h3>Not Found</h3>
    </div>
  );
}
